import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { tr } from "../lib/i18n";
import { contactUrl, NEEDS, useLicense } from "../lib/license";

// Shown instead of an error page when a menu item or button needs a bigger plan.
export const UpgradeDialog = ({ flag, onClose }) => {
  const { lic } = useLicense();
  const url = contactUrl(lic);
  const plan = tr(`lic.plan_${NEEDS[flag] || "pro" /* i18n-keys: growth,pro */}`);
  return (
    <Dialog open={Boolean(flag)} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Lock size={16} /> {tr("lic.upgrade_title")}</DialogTitle>
          <DialogDescription data-testid="upgrade-dialog-text">{tr("lic.available_on", { plan })}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2 justify-end">
          <button className="btn-secondary" onClick={onClose} data-testid="upgrade-dialog-close">{tr("x.close")}</button>
          {url ? <a className="btn-primary" href={url} target="_blank" rel="noopener noreferrer" data-testid="upgrade-dialog-contact">{tr("lic.upgrade_renew")}</a>
            : <span className="text-sm opacity-70 self-center" data-testid="upgrade-dialog-no-contact">{tr("lic.contact_wafa")}</span>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
